var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSmall = function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.341 9.067c0 5.516 4.472 9.988 9.988 9.988 1.197 0 2.346-.21 3.41-.598.303.607.78 1.054 1.237 1.357.268.177.535.31.767.398.211.081.42.136.585.142.223.03.424.032.588-.02a.535.535 0 0 0 .378-.416c.027-.142 0-.29-.014-.373l-.002-.008-.004-.023a1.2 1.2 0 0 1-.028-.21v-3.032a9.96 9.96 0 0 0 3.071-7.205c0-2.036-.653-4.042-1.688-5.611C17.598 1.892 16.159.72 14.569.43 13.41.219 12.25.412 11.136.695c-.42.107-.841.228-1.256.348q-.203.059-.402.115c-.546.156-1.08.3-1.605.4-2.031.389-3.91 1.156-5.285 2.385C1.203 5.18.34 6.874.34 9.067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.682,
    d: "M14.568.43c1.592.291 3.03 1.462 4.06 3.026a10.4 10.4 0 0 1 1.69 5.61 9.96 9.96 0 0 1-3.072 7.206v3.032c0 .056.011.116.028.21l.004.024.002.007c.015.083.041.231.014.372a.54.54 0 0 1-.378.416c-.164.053-.365.05-.588.02a2 2 0 0 1-.585-.14 4 4 0 0 1-.767-.4c-.456-.302-.934-.749-1.237-1.356a10 10 0 0 1-3.41.598c-5.516 0-9.988-4.472-9.988-9.988 0-2.193.862-3.887 2.248-5.124 1.376-1.23 3.254-1.996 5.285-2.385.525-.1 1.059-.244 1.605-.4q.2-.056.402-.115c.415-.12.836-.241 1.256-.348C12.251.412 13.411.22 14.568.431Zm0 0-.061.336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFBF",
    d: "M14.912.43c1.592.291 3.03 1.462 4.06 3.026a10.4 10.4 0 0 1 1.69 5.61 9.96 9.96 0 0 1-3.072 7.206v3.032c0 .24-.052.495-.197.7a.83.83 0 0 1-.696.35c-.167 0-.387-.056-.61-.142a4 4 0 0 1-.767-.398c-.456-.303-.934-.75-1.237-1.357a10 10 0 0 1-3.41.598c-5.516 0-9.988-4.472-9.988-9.988 0-2.193.862-3.887 2.247-5.124 1.377-1.23 3.255-1.996 5.285-2.385.526-.1 1.06-.244 1.606-.4q.2-.056.402-.115c.415-.12.836-.241 1.256-.348C12.595.412 13.754.22 14.912.431"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.682,
    d: "m14.912.43-.061.336m.061-.335c1.592.29 3.03 1.46 4.06 3.025a10.4 10.4 0 0 1 1.69 5.61 9.96 9.96 0 0 1-3.072 7.206v3.032c0 .24-.052.495-.197.7a.83.83 0 0 1-.696.35c-.167 0-.387-.056-.61-.142a4 4 0 0 1-.767-.398c-.456-.303-.934-.75-1.237-1.357a10 10 0 0 1-3.41.598c-5.516 0-9.988-4.472-9.988-9.988 0-2.193.862-3.887 2.247-5.124 1.377-1.23 3.255-1.996 5.285-2.385.526-.1 1.06-.244 1.606-.4q.2-.056.402-.115c.415-.12.836-.241 1.256-.348C12.595.412 13.754.22 14.912.431Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFFFF",
    fillRule: "evenodd",
    d: "M1.229 7.363c-.223 3.198 1.353 7.044 5.943 9.186l.128.06c.922.44 2.98 1.42 7.208.281.386.66 1.186 1.697 2.744 2.328v-3.094a9.62 9.62 0 0 0 3.07-7.059c0-3.93-2.529-7.763-5.468-8.3-1.492-.272-3.016.167-4.527.603-.685.198-1.367.395-2.043.524-3.405.652-6.288 2.373-7.055 5.47",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D56311",
    d: "M6.25 9.478a5.46 5.46 0 1 0 10.918 0 5.46 5.46 0 0 0-10.918 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-small_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDCC0B",
    d: "M6.486 8.844a5.46 5.46 0 1 0 10.918 0 5.46 5.46 0 0 0-10.918 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "M12.57 5.676a.853.853 0 0 0 .493 1.1q.357.136.596.4.271.3.362.734a.853.853 0 0 0 1.67-.349 3.25 3.25 0 0 0-.767-1.53 3.2 3.2 0 0 0-1.254-.85.853.853 0 0 0-1.1.495",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-small_svg__a",
    width: 12.184,
    height: 12.185,
    x: 5.617,
    y: 3.386,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_12189_233533",
    stdDeviation: 0.316
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-small_svg__b",
    width: 11.868,
    height: 12.185,
    x: 5.536,
    y: 2.119,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.949,
    dy: -1.266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.921569 0 0 0 0 0.568627 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12189_233533"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.158,
    dy: -0.554
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.435
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.848926 0 0 0 0 0.45842 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_12189_233533",
    result: "effect2_innerShadow_12189_233533"
  })))));
};
export default SvgLogoSmall;